import api from './api';

export const demoSchedulingService = {
  // Get all demo scheduling records
  getAllDemos: async (params = {}) => {
    try {
      const response = await api.get('/demo-scheduling', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting demo scheduling records:', error);
      throw error;
    }
  },

  // Get demo scheduling by ID
  getDemoById: async (id) => {
    try {
      const response = await api.get(`/demo-scheduling/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting demo scheduling record:', error);
      throw error;
    }
  },

  // Create new demo scheduling record
  createDemo: async (demoData) => {
    try {
      const response = await api.post('/demo-scheduling', demoData);
      return response.data;
    } catch (error) {
      console.error('Error creating demo scheduling record:', error);
      throw error;
    }
  },

  // Update demo scheduling record
  updateDemo: async (id, demoData) => {
    try {
      const response = await api.put(`/demo-scheduling/${id}`, demoData);
      return response.data;
    } catch (error) {
      console.error('Error updating demo scheduling record:', error);
      throw error;
    }
  },

  // Delete demo scheduling record
  deleteDemo: async (id) => {
    try {
      const response = await api.delete(`/demo-scheduling/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting demo scheduling record:', error);
      throw error;
    }
  },

  // Bulk delete demo scheduling records
  bulkDeleteDemos: async (demoIds) => {
    try {
      const response = await api.delete('/demo-scheduling/bulk', {
        data: { demoIds }
      });
      return response.data;
    } catch (error) {
      console.error('Error bulk deleting demo scheduling records:', error);
      throw error;
    }
  },

  // Get demo scheduling statistics
  getDemoStats: async () => {
    try {
      const response = await api.get('/demo-scheduling/stats/overview');
      return response.data;
    } catch (error) {
      console.error('Error getting demo scheduling stats:', error);
      throw error;
    }
  },

  // Get demos by status
  getDemosByStatus: async (status) => {
    try {
      const response = await api.get(`/demo-scheduling/status/${status}`);
      return response.data;
    } catch (error) {
      console.error('Error getting demos by status:', error);
      throw error;
    }
  },

  // Get demos by presenter
  getDemosByPresenter: async (presenterId) => {
    try {
      const response = await api.get(`/demo-scheduling/presenter/${presenterId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting demos by presenter:', error);
      throw error;
    }
  },

  // Get demos by type
  getDemosByType: async (type) => {
    try {
      const response = await api.get(`/demo-scheduling/type/${type}`);
      return response.data;
    } catch (error) {
      console.error('Error getting demos by type:', error);
      throw error;
    }
  },

  // Get upcoming demos
  getUpcomingDemos: async (days = 7) => {
    try {
      const response = await api.get('/demo-scheduling/upcoming/demos', {
        params: { days }
      });
      return response.data;
    } catch (error) {
      console.error('Error getting upcoming demos:', error);
      throw error;
    }
  },

  // Get demos by date range
  getDemosByDateRange: async (startDate, endDate) => {
    try {
      const response = await api.get('/demo-scheduling/date-range/demos', {
        params: { startDate, endDate }
      });
      return response.data;
    } catch (error) {
      console.error('Error getting demos by date range:', error);
      throw error;
    }
  }
};
